import { useEffect } from 'react';
import { useParams } from 'react-router';

import { applicationsActions } from '@store/applications/applications.slice';

import { useLazyLoadApplicationQuery } from '@hook/application/application.hooks';
import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLazyQuery } from '@hook/common/use-lazy-query.hook';
import { usePrevious } from '@hook/common/use-previous.hook';
import { isString } from '@util/data/is-exist';

export const useCurrentApplicationParams = () => {
  const { applicationId } = useParams();
  const prevApplicationId = usePrevious(applicationId);

  const { action } = useLazyQuery(
    useLazyLoadApplicationQuery(),
    applicationsActions,
    applicationsActions.setApplication,
  );

  useEffect(
    () => void (prevApplicationId !== applicationId && isString(applicationId) && action(applicationId)),
    [applicationId, prevApplicationId],
  );

  return useCurrentApplication(applicationId);
};
